export const SURVEY_SOCKET_EVENTS = {
  // Outbound — emitted to join / leave rooms.
  SUBSCRIBE_TO_SURVEYS: 'subscribeToSurveys',
  UNSUBSCRIBE_FROM_SURVEYS: 'unsubscribeFromSurveys',
  JOIN_SURVEY_ROOM: 'joinSurveyRoom',
  JOIN_QUOTA_TAB_ROOM: 'joinQuotaTabRoom',
  LEAVE_QUOTA_TAB_ROOM: 'leaveQuotaTabRoom',

  // Inbound - listening channels
  SURVEY_COMPLETES: 'surveyCompletes',
  BUYER_IN_PROGRESS_CHANNEL: 'buyerProgressChannelV3',
  SURVEY_STATUS_CHANGE: 'surveyStatusChange',
  SURVEY_SCORE_CHANGE: 'surveyScoreChange',
  DASHBOARD_UPDATE: 'dashboard',
} as const;
